import { PayloadSensorModel } from '../models/payloadBookingModels';
import { SensorModel } from '../models/sensorEntityModels';

export const payloadToCommonAreaSensor = ({ sensor_id, item_name, item_label, item_type }: PayloadSensorModel): SensorModel => {
  return { id: sensor_id ?? '', name: item_name ?? '', type: item_type ?? '', label: item_label ?? '' };
};
